import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  height: auto;
  padding: 4rem 2.5rem;
  width: 42.4rem;

  h1 {
    color: #2e353d;
    font-family: "Montserrat";
    font-size: 2rem;
    font-style: normal;
    font-weight: 800;
    line-height: 2.4rem;
    margin-bottom: 3.3rem;
  }
`;
